<div
    class="pi-dropdown my-profile-tooltip"
    (clickOutside)="focusLost()"
    piTesting="my-profile-tooltip"
>
    <div
        tooltip-on-click
        [tooltipContent]="myProfile"
        tooltipPlacement="bottom"
        [tooltipShow]="showProfile"
        piTesting="my-profile-tooltip-icon"
    >
        <button
            class="button button-sm button-circle-no-background"
            (click)="toggleProfileVisibility()"
        >
            <abstract-icon
                #generic
                class="color-primary"
                [iconType]="IconType.Person"
                [iconSize]="IconSize.Small"
            ></abstract-icon>
        </button>
        <tooltip-content #myProfile>
            <div class="color-neutral-900 profile-card">
                <div
                    [ngClass]="
                        showTabNavigation
                            ? 'profile-container'
                            : 'profile-container-no-tabs'
                    "
                >
                    <div class="person-header-container">
                        <div class="person-name-icon-container">
                            @if (showMe) {
                                <div class="person-header-icon">
                                    <abstract-icon
                                        [iconType]="
                                            self.referencePattern?.icon
                                                ?.abstractIconSVG
                                        "
                                        [iconSize]="IconSize.Big_45"
                                        class="profile-Icon"
                                    >
                                    </abstract-icon>
                                    <div class="profile-iconName">
                                        {{
                                            self.referencePattern?.key
                                                | translate
                                        }}
                                    </div>
                                </div>
                            }
                            <div class="person-name-email-container">
                                <div
                                    [ngClass]="
                                        self
                                            ? 'profile-name'
                                            : 'profile-name-no-icon'
                                    "
                                >
                                    {{ initData.user.fullName() }}
                                </div>
                                <div
                                    [ngClass]="
                                        self
                                            ? 'profile-email'
                                            : 'profile-email-no-icon'
                                    "
                                >
                                    {{ initData.user.email }}
                                </div>
                            </div>
                        </div>
                        <a
                            (click)="closeTooltip()"
                            class="color-neutral-900 tooltip-close"
                        >
                            <abstract-icon
                                [iconType]="IconType.Close"
                                [iconSize]="IconSize.M_large"
                            >
                            </abstract-icon>
                        </a>
                    </div>
                    <!-- Need to change to use <ng-content> to make more generic -->
                    @if (showTabNavigation) {
                        <div class="profile-nav">
                            @for (tab of navTabs; track tab; let i = $index) {
                                <div
                                    class="navTab"
                                    (click)="navigateToTabSection(navTabs[i])"
                                >
                                    <div class="navTab-text">
                                        {{
                                            TR.notImplementedKey(navTabs[i])
                                                | uppercase
                                        }}
                                    </div>
                                    @if (highlightTab(navTabs[i])) {
                                        <div
                                            class="navTab-border-gradient"
                                        ></div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    <!-- use ngcontent here too -->
                    <div class="profile-tab">
                        @if (currentTab === navTabs[0]) {
                            <my-profile-person-info
                                [self]="self"
                                class="my-profile-person-info-component"
                            ></my-profile-person-info>
                        }
                        @if (showBaReportsTab && currentTab === navTabs[1]) {
                            <users-and-ba-reports
                                (reportDownloading)="
                                    reportDownloadInProgress = true
                                "
                            ></users-and-ba-reports>
                        }
                    </div>

                    <div class="profile-footer">
                        <button
                            class="button button-tertiary button-sm logout-button"
                            (click)="logout()"
                        >
                            {{ 'label.common-terms.logout' | translate }}
                        </button>
                        <div class="information-row">
                            <span
                                class="layoutCenterAlign color-neutral-700 version-container"
                                >{{ getPiVersion() }}
                            </span>
                            <a class="profile-privacy-link" [href]="PrivacyLink"
                                >{{ 'linklabel.privacypolicy' | translate }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </tooltip-content>
    </div>
</div>
